import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class ReportBtbOrder {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.pageIndex = data.pageIndex || PAGINATION.pageIndex;
        this.pageSize = data.pageSize || PAGINATION.pageSize;
        this.totalCount = data.totalCount || 0;
        this.totalPage = Math.ceil(parseInt(data.totalCount || 0) / parseInt(2));
        this.orderBy = data.orderBy || 'transactionDate';
        this.orderByDesc = data.orderByDesc || 'true';
        this.items = data.result && data.result.map(item => new ReportBtbOrderItem(item));
    }

}

export class ReportBtbOrderItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.hotelName = data.hotelName;
        this.fullname = data.fullname;
        this.email = data.email;
        this.phoneNumber = data.phoneNumber;
        this.transactionDate = data.transactionDate;
        this.arrivalDate = data.arrivalDate;
        this.departureDate = data.departureDate;
        this.stayNight = data.stayNight;
        this.villaOwnerCode = data.villaOwnerCode;
        this.itineraryNumber = data.itineraryNumber;
        this.roomConfirmationNumber = data.roomConfirmationNumber;
        this.roomTypeName = data.roomTypeName;
        this.ratePlanCode = data.ratePlanCode;
        this.fullnameCustomer = data.fullnameCustomer;
        this.total = data.total;
    }
}
